<template>
  <div class="releasePass_wrapper">
    <div id="releasePass_conent">
      <div class="header">
        <div class="header_top">
          <el-input
            v-model="keyword"
            placeholder="请输入..."
            clearable
            @input="queryByPageRelease"
          />
        </div>
        <div class="header_bottom">
          <van-field
            @click="showTime"
            readonly
            v-model="releaseDate"
            placeholder="请选择时间"
          />
          <van-field
            @click="showState"
            readonly
            v-model="releaseStatusText"
            placeholder="请选择"
          >
            <template #button>
              <!-- <i class="el-icon-caret-bottom"></i> -->
              <img class="img" src="@/assets/mobVisitor/sanjiao.png" alt="" />
            </template>
          </van-field>
          <van-field
            @click="showType"
            readonly
            v-model="releaseTypeText"
            placeholder="请选择"
          >
            <template #button>
              <img class="img" src="@/assets/mobVisitor/sanjiao.png" alt="" />
            </template>
          </van-field>
        </div>
      </div>
      <div class="content">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            class="content_Items"
            @click="toUrl(item)"
            v-for="(item, index) in releaseList"
            :key="index"
          >
            <div class="item_top">
              <div class="top_left">
                <div class="left_imgCon">
                  <img
                    class="left_img"
                    src="@/assets/mobVisitor/car.png"
                    alt=""
                  />
                </div>

                <div class="title">{{ item.carNumber }}</div>
                <div
                  class="item_type"
                  :class="
                    item.releaseType == 1
                      ? 'green'
                      : item.releaseType == 2
                      ? 'blur'
                      : item.releaseType == 3
                      ? 'red'
                      : ''
                  "
                >
                  {{
                    item.releaseType == 1
                      ? "车辆放行"
                      : item.releaseType == 2
                      ? "物品放行"
                      : item.releaseType == 3
                      ? "其他放行"
                      : ""
                  }}
                </div>
              </div>
              <div
                class="top_delete"
                @click.stop="chandleDelete(item)"
                v-if="showDelete"
              >
                <van-icon name="delete-o" />
              </div>
            </div>
            <div class="item_center">
              <div class="center_name">
                姓名：{{
                  item.releaseType == 1 ? item.driverName : item.driverName
                }}
              </div>
              <div class="center_phone">联系方式：{{ item.visitorPhone }}</div>
              <div class="center_imgcon">
                <img
                  v-if="item.approvalStatus == 3"
                  class="center_img"
                  src="@/assets/mobVisitor/yishenhe.png"
                  alt=""
                />
                <img
                  v-if="item.approvalStatus == 2"
                  class="center_img"
                  src="@/assets/mobVisitor/shenhezhong.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <van-popup v-model="showDate" position="bottom">
      <van-datetime-picker
        v-model="date"
        type="date"
        title="选择日期"
        @confirm="comfirmTime"
        @cancel="showDate = false"
      />
    </van-popup>
    <van-popup v-model="showStateList" position="bottom">
      <van-picker
        show-toolbar
        :columns="stateList"
        @confirm="confirmState"
        @cancel="cancelState"
      />
    </van-popup>
    <van-popup v-model="showTypeList" position="bottom">
      <van-picker
        show-toolbar
        :columns="typeList"
        @confirm="confirmType"
        @cancel="cancelType"
      />
    </van-popup>
  </div>
</template>

<script>
import api from "@/apis";
import moment from "moment";
import apiLogin from "@/apis";
import { getToken } from "@/utils/cookie";
export default {
  name: "releaseList",
  data() {
    return {
      keyword: "",
      releaseDate:moment(new Date()).format('YYYY-MM-DD'),
      date: new Date(),
      showDate: false,
      minDate: new Date(),
      releaseStatus: "",
      releaseStatusText: "全部",
      showStateList: false,
      stateList: [],
      releaseType: "",
      releaseTypeText: "全部",
      showTypeList: false,
      typeList: [],
      page: 1,
      pageSize: 20,
      totalAll: 0,
      loading: false,
      finished: false,
      releaseList: [],
      showDelete: false,
      parkIds: "",
      username: ""
    };
  },
  created() {},
  mounted() {
    if (sessionStorage.getItem("parkIds")) {
      const dataType = JSON.parse(sessionStorage.getItem("dataType"));
      // const dataType = res.data.map(item => item.dataType);
      this.showDelete = dataType?.includes(4);
      this.parkIds = JSON.parse(sessionStorage.getItem("parkIds"));
    }
    this.queryByStatus();
    this.queryByType();
    let token = getToken();
    if (token) {
      this.username = token;
      // this.queryByPageRelease();
      this.queryRole(token);
    } else {
      this.$bus.$on("processToken", res => {
        Promise.resolve(this.getHrToken(res)).then(() => {
          console.log(res);
          this.username = res;
          // this.queryByPageRelease();
          this.queryRole(res);
        });
      });
    }
  },

  methods: {
    // 获取hrToken
    getHrToken(username) {
      return new Promise(resolve => {
        // console.log("username:" + new Date(), username);
        if (username) {
          let thisname = username;
          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }
          apiLogin.getUserToken({ username: thisname }).then((data) => {
            const info = data.data;;
            window.sessionStorage.hrToken = info.auth_token;
            window.sessionStorage.empNo = info.empNo;
            resolve();
          });
          // this.queryUsername(thisname);
        } else {
          // console.log("未登录");
          resolve();
        }
      });
    },
    onLoad() {
      // let token = getToken();
      // if (token) {
      //   this.queryUsername(token);
      // } else {
      //   this.$bus.$on("processToken", res => {
      //     Promise.resolve(this.getHrToken(res)).then(() => {
      //       console.log(res);
      //       this.queryRole(res)
      //     });
      //   });
      // }
      if (this.username) {
        this.queryByPageRelease();
      }
    },
    //获取状态列表
    queryByStatus() {
      api
        .queryByTypeList({
          type: "approvalStatus"
        })
        .then(res => {
          if (res.code == 200) {
            this.stateList = res.data.map(item => {
              return {
                text: item.value,
                value: item.key
              };
            });
            this.stateList.unshift({
              text: "全部",
              value: ""
            });
          }
        });
    },
    //获取放行类型
    queryByType() {
      api
        .queryByTypeList({
          type: "releaseType"
        })
        .then(res => {
          if (res.code == 200) {
            this.typeList = res.data.map(item => {
              return {
                text: item.value,
                value: item.key
              };
            });
            this.typeList.unshift({
              text: "全部",
              value: ""
            });
          }
        });
    },
    //获取放行列表
    queryByPageRelease() {
      api
        .queryByPageRelease({
          keyword: this.keyword,
          releaseDate: this.releaseDate,
          releaseStatus: this.releaseStatus,
          releaseType: this.releaseType,
          page: this.page,
          pageSize: this.pageSize,
          parkIdStr: this.parkIds,
          username: this.username
        })
        .then(res => {
          this.totalAll = res.data.total;
          this.finished = false;
          if (this.page === 1) {
            this.releaseList = res.data.list;
          } else {
            this.releaseList = this.releaseList.concat(res.data.list);
          }
          if (this.releaseList.length < this.totalAll) {
            this.page = this.page + 1;
          } else {
            this.finished = true;
          }
          this.loading = false;
          // if (res.code == 200) {
          //   this.releaseList = res.data.list;
          // }
        });
    },
    //显示时间选择器
    showTime() {
      this.showDate = true;
    },
    //确认时间
    comfirmTime(value) {
      this.page = 1;
      this.releaseDate = moment(value).format("YYYY-MM-DD");
      this.showDate = false;
      this.queryByPageRelease();
    },
    //状态
    showState() {
      this.showStateList = true;
    },
    //状态确认
    confirmState(value) {
      this.page = 1;
      this.releaseStatusText = value.text;
      this.releaseStatus = value.value;
      this.showStateList = false;
      this.queryByPageRelease();
    },
    //状态取消
    cancelState() {
      this.showStateList = false;
    },
    //类型
    showType() {
      this.showTypeList = true;
    },
    //类型确认
    confirmType(value) {
      this.page = 1;
      this.releaseTypeText = value.text;
      this.releaseType = value.value;
      this.showTypeList = false;
      this.queryByPageRelease();
    },
    //类型取消
    cancelType() {
      this.showTypeList = false;
    },
    //跳转放行详情页
    toUrl(item) {
      this.$router.push({
        path: "/releaseDetail",
        query: {
          id: item.id
        }
      });
    },
    //删除放行记录
    chandleDelete(item) {
      this.$dialog
        .confirm({
          message: "您是否确认删除当前放行条？",
          confirmButtonText: "确认",
          cancelButtonText: "取消"
        })
        .then(() => {
          api.deleteReleaseRecord({ ids: [item.id] }).then(() => {
            this.$message.success("删除成功!");
            this.page = 1;
            this.queryByPageRelease();
          });
        })
        .catch(() => {
          // on cancel
          console.log("取消");
        });
    },

    // queryUsername(token) {
    //   api
    //     .queryByUsername({
    //       username: token
    //     })
    //     .then(({ data }) => {
    //       this.queryRole(data.username);
    //     });
    // },
    //查询角色
    queryRole(username) {
      api.queryRoleApi({ username }).then(res => {
        if (res.code == 200) {
          const dataType = res.data.map(item => item.dataType);
          this.showDelete = dataType?.includes(4);
          this.parkIds = res.data.map(item => item.parkIds).join(",");
          console.log("this.parkIds", this.parkIds);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  #releasePass_conent {
    width: 100%;
  }
  ::v-deep .van-popup {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  #releasePass_conent {
    width: 276px * $zoom;
  }
  ::v-deep .van-popup {
    width: 276px * $zoom;
    left: initial;
  }
}
.releasePass_wrapper {
  display: flex;
  justify-content: center;
  #releasePass_conent {
    font-size: 16px * $zoom;
    position: relative;
    background-color: #f7f9fa;
    height: 100vh;
    .header {
      background-color: #fff;
      padding: 13px * $zoom 13px * $zoom 0 13px * $zoom;
      .header_top {
        margin: 0 10px;

        ::v-deep .el-input__inner {
          background-color: #f7f9fa;
          border-radius: 30px;
          border: 0;
          padding: 35px 25px;
        }

        // ::v-deep .van-cell__value {
        //   background-color: #f7f9fa;
        // }
      }
      .header_bottom {
        display: flex;
        padding: 5px * $zoom 0;
        .img {
          width: 6.8px * $zoom;
          height: 4px * $zoom;
        }
        ::v-deep {
          .van-cell::after {
            border: 0;
          }
        }
      }
    }
    .content {
      padding: 0 11px * $zoom;
      margin: 11px * $zoom 0;
      .content_Items {
        height: 104px * $zoom;
        background: #ffffff;
        box-shadow: 0px 1px * $zoom 4px * $zoom 0px rgba(0, 0, 0, 0.08);
        border-radius: 8px * $zoom;
        padding: 11px * $zoom;
        margin-bottom: 12px * $zoom;
        .item_top {
          display: flex;
          justify-content: space-between;
          .top_left {
            display: flex;
            align-content: center;
            flex-wrap: wrap;
            .left_imgCon {
              display: flex;
              align-content: center;
              flex-wrap: wrap;
              .left_img {
                width: 16px * $zoom;
                height: 13px * $zoom;
              }
            }

            .title {
              font-weight: bold;
              font-size: 13px * $zoom;
              color: #282b32;
              margin: 0 10px * $zoom;
            }
            .item_type {
              font-weight: 400;
              font-size: 7.5px * $zoom;

              border-radius: 2px * $zoom;
              padding: 2px * $zoom 6px * $zoom;
              line-height: 13px * $zoom;
            }
            .green {
              color: #4ea27c;
              background: #edf6f2;
            }
            .blur {
              color: #167cf2;
              background: #e7f2fd;
            }
            .red {
              color: #e6425f;
              background: #fbedec;
            }
          }
          .top_delete {
          }
        }
        .item_center {
          position: relative;
          .center_name {
            font-weight: 400;
            font-size: 9.5px * $zoom;
            color: #282b32;
            margin-top: 14px * $zoom;
          }
          .center_phone {
            font-weight: 400;
            font-size: 9.5px * $zoom;
            color: #282b32;
            margin-top: 9.5px * $zoom;
          }
          .center_imgcon {
            position: absolute;
            right: 0;
            top: 10px * $zoom;
            .center_img {
              width: 38.7px * $zoom;
              height: 38.7px * $zoom;
            }
          }
        }
      }
    }
  }
}
</style>
